import { ActionTree } from 'vuex';
import ApiUrl from '../../../api/url';
import { NodeTypeState } from './types';
import { RootState } from '../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../error-type';

export const actions: ActionTree<NodeTypeState, RootState> = {
    /**
     * 通常ノードのノード種別一覧取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async normalNodeIndex({ dispatch, commit }) {
        try {
            commit(types.NORMAL_NODE_INDEX_START);
            const resData = await dispatch(
                'auth/api',
                { method: 'get', url: ApiUrl.NodeTypes.NORMAL_NODE_INDEX },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.NORMAL_NODE_INDEX_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.NORMAL_NODE_INDEX_FAILURE, params);
        }
    },

    /**
     * シンプルノードのノード種別一覧取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async simpleNodeIndex({ dispatch, commit }) {
        try {
            commit(types.SIMPLE_NODE_INDEX_START);
            const resData = await dispatch(
                'auth/api',
                { method: 'get', url: ApiUrl.NodeTypes.SIMPLE_NODE_INDEX },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SIMPLE_NODE_INDEX_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.SIMPLE_NODE_INDEX_FAILURE, params);
        }
    },

    /**
     * 画面切り替え時のstoreの消去
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute({ commit }) {
        /* 消す必要がない */
    },
};
